export const hexToRgb = (hex: string): Array<number> => {
  if (hex === 'transparent') {
    return [0, 0, 0, 0];
  }

  return hex.match(/\w\w/g)?.map((x) => parseInt(x, 16)) || [0, 0, 0];
};
